export default __webpack_public_path__ + "f3d2be7bcadf4391bbe18c50221450e6.png";